import * as React from 'react'

export function ExploreWhatsnew(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M18.677 15.975c-.755.534-1.188 1.294-1.188 2.084a1.49 1.49 0 01-2.977 0c0-1.769.892-3.414 2.445-4.515.442-.311.846-.939.658-1.768a1.63 1.63 0 00-1.207-1.205 1.674 1.674 0 00-1.444.315 1.658 1.658 0 00-.626 1.3 1.488 1.488 0 11-2.976 0c0-1.418.636-2.74 1.745-3.626a4.66 4.66 0 013.96-.893 4.606 4.606 0 013.452 3.452 4.66 4.66 0 01-1.842 4.856M16 24.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3M16 4C9.372 4 4 9.373 4 16s5.372 12 12 12c6.627 0 12-5.373 12-12S22.627 4 16 4'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
